import {inject} from '@angular/core';
import {AuthenticationService} from '@core/auth';
import {Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import * as ifvisible from 'ifvisible.js';

const inActiveTimeForUser = 3600; // 60min

export const removeVisibleEvent = () => ['idle', 'blur', 'focus'].forEach(evt => ifvisible.off(evt));

export const isActiveUserSession = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  authenticationService.refreshToken().pipe(takeUntilDestroyed()).subscribe();

  ifvisible.setIdleDuration(inActiveTimeForUser);

  ifvisible.on('idle', () => {
    if (ifvisible.getIdleInfo().timeLeft === 0) {
      authenticationService.logout();
      router.navigate(['/loginredirect']);
      removeVisibleEvent();
    }
  });

  /** If the User is out from the app - the timeout need to be cleared */
  ifvisible.on('blur', () => authenticationService.clearTokenTimeout());

  /** If The User back again to the app - need to start the timer again and refresh the token */
  ifvisible.on('focus', () => authenticationService.startRefreshTokenTimer());
};
